import React from "react";
import {
  Box,
  SimpleGrid,
  Card
} from "@chakra-ui/react";
import Campaigns from "../campaigns/components/Campaigns";

const campaignsData = [
  {
    id: 1,
    name: "Seasonal Discount",
    description: "Enjoy a 20% discount on all summer menu items!",
    discount: 20,
    startDate: "2024-06-01",
    endDate: "2024-08-31",
    code: "SUMMER20"
  },
  {
    id: 2,
    name: "Happy Hour",
    description: "Get a 15% discount on orders between 2 PM and 5 PM!",
    discount: 15,
    startDate: "2024-10-26",
    endDate: "2024-10-26",
    startTime: "14:00",
    endTime: "23:59",
    code: "HAPPY15"
  },
  {
    id: 3,
    name: "New Year Special",
    description: "Celebrate the New Year with us and enjoy a 25% discount!",
    discount: 25,
    startDate: "2024-12-31",
    endDate: "2025-01-01",
    startTime: "00:00",
    endTime: "23:59",
    code: "NEWYEAR25"
  },
  {
    id: 4,
    name: "Valentine's Day Offer",
    description: "Get a romantic dinner for two at 30% off!",
    discount: 30,
    startDate: "2025-02-14",
    endDate: "2025-02-14",
    startTime: "18:00",
    endTime: "22:00",
    code: "LOVE30"
  },
  {
    id: 5,
    name: "Weekend Special",
    description: "Enjoy a flat 10% off on all weekend orders!",
    discount: 10,
    startDate: "2024-10-26",
    endDate: "2025-10-31",
    startTime: "00:00",
    endTime: "23:59",
    code: "WEEKEND10"
  }
];


export default function Overview() {
  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      <SimpleGrid 
        mb="20px" 
        columns={{ base: 1, md: 1, xl: 1 }} 
        spacing={{ base: "20px", xl: "20px" }}>
        <Card px="0px">
          <Campaigns campaignsData={campaignsData} />
        </Card>
      </SimpleGrid>
    </Box>
  );
}
